import { render, staticRenderFns } from "./PopupBoard.vue?vue&type=template&id=2a8a29e6&scoped=true"
import script from "./PopupBoard.vue?vue&type=script&lang=js"
export * from "./PopupBoard.vue?vue&type=script&lang=js"
import style0 from "./PopupBoard.vue?vue&type=style&index=0&id=2a8a29e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a29e6",
  null
  
)

export default component.exports